import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
const style = {
    grid: {
        marginRight: '-15px',
        marginLeft: '-15px',
        width: 'auto',
    },
};
function GridContainer({ ...props }) {
    const { classes, children, className, ...rest } = props;
    return (React.createElement(Grid, Object.assign({ container: true }, rest, { className: classes.grid + ' ' + className }), children));
}
GridContainer.defaultProps = {
    className: '',
};
GridContainer.propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
};
export default withStyles(style)(GridContainer);
//# sourceMappingURL=GridContainer.js.map